import * as z from 'zod';
import { SpotifyTrack } from '@/services/spotifyService';

export const sequenceSchema = z.object({
  title: z.string().min(1, 'Title is required'),
  artist: z.string().min(1, 'Artist is required'),
  duration: z.number().optional(),
  description: z.string().optional(),
  software_type: z.enum(['xLights', 'Light-O-Rama', 'Vixen', 'Other']),
  holiday_type: z.enum(['Christmas', 'Halloween', 'FourthOfJuly', 'Easter', 'Thanksgiving', 'Hanukkah'], {
    required_error: 'Holiday type is required',
  }),
  genre: z.string().optional(),
  price: z.number().min(0, 'Price must be 0 or greater'),
  is_free: z.boolean().default(false),
  display_id: z.string().optional(),
  album: z.string().optional(),
  album_cover_url: z.string().optional(),
});

export type SequenceFormData = z.infer<typeof sequenceSchema>;

export interface UploadedFile extends File {
  uploadedPath?: string;
  uploadedSize?: number;
}

export interface UploadWizardState {
  currentStep: number;
  uploadedFile: UploadedFile | null;
  selectedSpotifyTrack: SpotifyTrack | null;
  formData: Partial<SequenceFormData>;
  uploadProgress: number;
  isUploading: boolean;
}

export type WizardStep = 'file' | 'metadata' | 'spotify' | 'pricing' | 'review';

export const WIZARD_STEPS: { id: WizardStep; label: string; description: string }[] = [
  { id: 'file', label: 'Upload File', description: 'Select your sequence file' },
  { id: 'metadata', label: 'Basic Info', description: 'Title, artist, and details' },
  { id: 'spotify', label: 'Music Match', description: 'Link to Spotify (optional)' },
  { id: 'pricing', label: 'Pricing', description: 'Set your price' },
  { id: 'review', label: 'Review', description: 'Review and submit' },
];